import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "px-7 py-5" }
const _hoisted_8 = { class: "row mb-8" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "form-label required" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "form-label required" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "col-lg-8 fv-row" }
const _hoisted_21 = { class: "row mb-6" }
const _hoisted_22 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_23 = { class: "col-lg-8 fv-row" }
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "col-lg-8 fv-row d-flex align-items-center" }
const _hoisted_27 = { class: "form-check form-check-solid form-switch" }
const _hoisted_28 = {
  class: "form-check-label",
  for: "onlyFullySoldCheckbox"
}
const _hoisted_29 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_30 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_31 = { class: "badge badge-light-success fs-6" }
const _hoisted_32 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_33 = { class: "svg-icon svg-icon-2" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "indicator-label" }
const _hoisted_36 = { class: "indicator-progress" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'reports'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('auctionsReport')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _withModifiers(_ctx.onSubmitCreate, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.translate('dateFrom')), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "form-control form-control-sm form-control-solid",
                        placeholder: _ctx.translate('From'),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.dateFrom) = $event)),
                        required: ""
                      }, null, 8, _hoisted_11), [
                        [_vModelText, _ctx.selectedItems.dateFrom]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('dateTo')), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "form-control form-control-sm form-control-solid",
                        placeholder: _ctx.translate('To'),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.dateTo) = $event)),
                        required: ""
                      }, null, 8, _hoisted_14), [
                        [_vModelText, _ctx.selectedItems.dateTo]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('propertyCategories')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedItems.propertyTypeIds,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.propertyTypeIds) = $event)),
                        mode: "tags",
                        required: false,
                        label: "title",
                        trackBy: "title",
                        searchable: true,
                        canDeselect: true,
                        options: _ctx.propertyTypes,
                        placeholder: _ctx.translate('selectPropertyCategories'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedItems.areaIds,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedItems.areaIds) = $event)),
                        mode: "tags",
                        required: false,
                        label: "titleAr",
                        trackBy: "titleAr",
                        searchable: true,
                        canDeselect: true,
                        options: _ctx.areas,
                        placeholder: _ctx.translate('selectAreas'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('organizers')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedItems.organiserIds,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems.organiserIds) = $event)),
                        mode: "tags",
                        required: false,
                        label: "titleAr",
                        trackBy: "titleAr",
                        searchable: true,
                        canDeselect: true,
                        options: _ctx.organizers,
                        placeholder: _ctx.translate('selectOrganizers'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('salePercentage')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedItems.onlyFullySold) = $event)),
                          id: "onlyFullySoldCheckbox"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.selectedItems.onlyFullySold]
                        ]),
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('onlyFullySold')), 1)
                      ])
                    ])
                  ]),
                  (_ctx.showExportBtn && _ctx.data && _ctx.data.data && _ctx.data.data.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.translate('NumOfData')) + ": " + _toDisplayString(_ctx.data.data.length), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('back')), 1),
                (_ctx.showExportBtn && _ctx.data && _ctx.data.data && _ctx.data.data.length > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-light-success me-2",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_33, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil009.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('export')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "submit",
                  id: "kt_account_profile_details_submit",
                  ref: "submitButton",
                  class: "btn btn-primary",
                  disabled: !_ctx.isFormValid
                }, [
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.translate('query')), 1),
                  _createElementVNode("span", _hoisted_36, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_37
                  ])
                ], 8, _hoisted_34)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ]))
    : _createCommentVNode("", true)
}